<div id="payment_form"><h4>Pay by Credit Card</h4>
  <div class="payment-terms-wrapper">
    <p>To proceed with this payment, you must check the box below to confirm that you understand and accept
      the Association's <a [href]="variablesService.paymentPolicy" target="_blank">payment and refund policies</a>
      (collectively the Payment Terms).</p>
    <p>Payments made will appear on your credit card billing statement under the name 'REALTOR Association/MLS'
    </p>
  </div>

  <form (ngSubmit)="makePayment()">
    <div class="row">
      <div class="col-12">
        <tgf-form-control-question-processor
          [parentModel]="actualModel"
          [questionsToInclude]="['termsOfPayment']"
          [form]="questionForm" [questionJson]="questionJson">
        </tgf-form-control-question-processor>
      </div>
    </div>
    <div class="row justify-content-between card-details-wrapper">
      <div class="col-sm-12 col-xl-4 card pt-3">
        <h4>Your Card Details</h4>
        <tgf-form-control-question-processor
          [parentModel]="actualModel"
          [questionsToSkip]="['termsOfPayment']"
          [form]="questionForm" [questionJson]="questionJson">
        </tgf-form-control-question-processor>
      </div>

      <div class="col-sm-12 card-address-details card pt-3">
        <tgf-address-form-widget [form]="questionForm"
                                 [requiresValidation]="false"
                                 [inputModel]="getAddressFormModel()"
                                 [parentModel]="actualModel">
        </tgf-address-form-widget>
      </div>
    </div>

    <div class="payment-error row" *ngIf="paymentFormWidgetService.paymentErrorMessage"
         [innerHTML]="paymentFormWidgetService.paymentErrorMessage">
    </div>

    <div class="payment-buttons-wrapper">
      <button
        class="sd-btn sd-btn--action ms-auto mt-3"
        [disabled]="isItLoading()">
        Pay {{ StringUtils.toMoney(totalCharge) }}
      </button>
    </div>
    <div id="payment_result"></div>
  </form>
</div>

<tg-spinner [blockAll]="true" *ngIf="isItLoading()"></tg-spinner>
